// extracted by mini-css-extract-plugin
export default {"modal_window__wrapper":"styles_modal_window__wrapper__1H+xd","active":"styles_active__m3lsI","modal_window__content":"styles_modal_window__content__Z82qc"};